<template>
    <div
        class="pages row d-flex no-gutters justify-content-around"
        v-if="initialized"
    >
        <div
            v-for="(page, idx) in pages"
            :key="page.id"
            :class="[
                'col-lg-6 col-md-12',
                'px-lg-3',
                idx < pages.length - 1 ? 'mb-5' : '',
            ]"
        >
            <a
                :class="['page', 'text-decoration-none']"
                href="#"
                @click.prevent="openPage(page)"
            >
                <img :src="page.image_url" class="img-fluid" />

                <div class="pl-3 pt-2 text-dark">
                    <div class="text-uppercase" style="font-size: 15px">
                        {{ page.category.label }}
                    </div>
                    <div class="font-weight-bold" style="font-size: 20px">
                        {{ page.title }}
                    </div>
                </div>
            </a>
        </div>

        <SbModal
            centered
            hide-footer
            :title="selectedPage ? selectedPage.title : ''"
            @shown="onModalShown"
            v-model="modalOpen"
            v-if="selectedPage"
        >
            <template v-if="selectedPage">
                <div
                    v-for="block in selectedPage.blocks"
                    :key="block.id"
                    class="mb-3"
                >
                    <img
                        :src="block.image_url"
                        class="mb-3"
                        style="width: 100%; height: auto"
                        v-if="block.has_image"
                    />

                    <h5 class="mb-2" v-if="block.has_title">
                        {{ block.title }}
                    </h5>

                    <div
                        class="mb-3"
                        style="white-space: pre-line"
                        v-if="block.has_body"
                    >
                        {{ block.body }}
                    </div>

                    <div
                        class="mb-3"
                        style="
                            position: relative;
                            width: 100%;
                            padding-top: 75%;
                        "
                        v-if="block.has_youtube_url"
                    >
                        <iframe
                            style="
                                position: absolute;
                                top: 0;
                                left: 0;
                                bottom: 0;
                                right: 0;
                                width: 100%;
                                height: 100%;
                            "
                            :src="youtubeEmbedUrl(block.youtube_url)"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>

                    <div
                        class="mb-3"
                        v-if="block.has_cta"
                        style="text-align: center"
                    >
                        <SbButton
                            variant="primary"
                            :href="block.cta_url"
                            target="_blank"
                        >
                            {{ block.cta_title }}
                        </SbButton>
                    </div>
                </div>
            </template>
        </SbModal>
    </div>
    <div v-else>
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ $t("general.loading") }}...</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.pages {
    width: 100%;

    a.page {
        img {
            width: 100%;
            height: auto;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        p {
            margin-top: 8px;
            margin-bottom: 0px;
            text-align: center;
            text-decoration: none;
            color: black;
        }
    }
}
</style>

<script setup>
import axios from "axios";
import { computed, onMounted, ref } from "vue";

import { useActionLog } from "../../composables/useActionLog";
import SbButton from "../sb/SbButton.vue";
import SbModal from "../sb/SbModal.vue";

const props = defineProps({
    quoteKey: { type: String, default: undefined },
    isTemplate: { type: Boolean, default: false },
});

const actionLog = useActionLog();
const pages = ref(undefined);
const selectedPage = ref(undefined);
const modalOpen = ref(false);
const initialized = computed(() => pages.value !== undefined);

onMounted(loadPages);

async function loadPages() {
    const response = await axios.get(`/quote/${props.quoteKey}/read_more_pages?is_template=${props.isTemplate}`);
    const loadedPages = response.data.data;
    for (const page of loadedPages) {
        const blocksResponse = await axios.get(`/quote/${props.quoteKey}/read_more_pages/${page.id}/content_blocks?is_template=${props.isTemplate}`);
        page.blocks = blocksResponse.data.data;
    }
    pages.value = loadedPages;
}

function openPage(page) {
    selectedPage.value = page;
    modalOpen.value = true;
}
function youtubeEmbedUrl(youtubeUrl) {
    const parts = youtubeUrl.split("/");
    return `https://www.youtube.com/embed/${parts[parts.length - 1]}`;
}
function onModalShown() {
    actionLog.logReadMoreOpen(props.quoteKey, selectedPage.value?.title ?? "");
}
</script>
